var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { gql } from '@oneaudi/onegraph-service';
import merge from 'lodash/merge';
import isEqual from 'lodash/isEqual';
import { isEquipmentChange, StateEvents, isModelChange, isSpecificCarData, isTrimlineChange, isAudiCodeError, isConfiguredCar, isCarId, isfinancingInput, FeatureChangeAction, } from '../types';
import { getDefaultFinancingInput, getDomain } from '../utils/webcalc-domains';
import { Carbycode } from '../graphql/car-by-code';
import { carByPr } from '../graphql/car-by-pr';
import { openConfigAssistant } from './open-config-assistant';
import { QueryBuilder, QueryType } from './query-builder';
import { STATE_MANAGER_QUERY } from './state-manager-query';
export var CONFIG_ASSISTANT_VERSION = '1.4.3';
var GlobalStateManager = /** @class */ (function () {
    function GlobalStateManager(_carlineInput, _oneGraphClient, _carlineID2Urls, _language, _countryCode, featureServices, options) {
        var _this = this;
        this._carlineInput = _carlineInput;
        this._oneGraphClient = _oneGraphClient;
        this._carlineID2Urls = _carlineID2Urls;
        this._language = _language;
        this._countryCode = _countryCode;
        this._isSsr = typeof window === 'undefined';
        this._isDefaultConfiguration = true;
        this._lastUsedQueryVariableForSingleQuery = new Map();
        this._subscribers = new Map();
        this._options = {
            debug: false,
            enableSimpleConflictResolution: false,
            configAssistantVersion: CONFIG_ASSISTANT_VERSION,
            enableUserSession: true,
            enableSingleQueryMode: false,
        };
        this._loadedFromUserSession = false;
        if (options) {
            this._options = __assign(__assign({}, this._options), options);
        }
        this._layerManager = featureServices.layerManager;
        this._logger = featureServices.logger;
        this._asyncSsrManager = featureServices.asyncSsrManager;
        this._serializedStateManager = featureServices.serializedStateManager;
        this._financingInput = getDefaultFinancingInput({ country: _countryCode, language: _language });
        this._webCalcDomain = getDomain({ country: _countryCode, language: _language });
        // Lets save our state if we are used on the server
        if (this._serializedStateManager && this._asyncSsrManager) {
            this._serializedStateManager.register(function () {
                // check if CarId is set, if not we return an empty object
                if ((_this._options.enableSingleQueryMode && _this._subscribers.size > 0) || _this._carId) {
                    return _this._getStateToSave();
                }
                return JSON.stringify({});
            });
        }
        // if reactivated again the this._initialize() method needs to be placed here
    }
    /**
     * Initialize the state-manager based on some sourinding parameters.
     * Load config if audicode or prstring parameter is set, or try to load from user session
     */
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore TS6133
    GlobalStateManager.prototype._initialize = function () {
        var _a, _b;
        var audiCode = null;
        var prString = null;
        if (!this._isSsr) {
            if ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href) {
                var currentUrl = new URL((_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.href);
                this._logDebug('Try to get prString or audiCode from URL', currentUrl);
                audiCode =
                    currentUrl.searchParams.get('audiCode') || currentUrl.searchParams.get('audicode');
                prString =
                    currentUrl.searchParams.get('prString') || currentUrl.searchParams.get('prstring');
            }
            if (audiCode) {
                this._logDebug('Detected audiCode in URL', audiCode);
                this.loadAudiCode(audiCode);
            }
            else if (prString) {
                this._logDebug('Detected prString in URL', prString);
                this.loadPrString(prString);
            }
            else if (this._options.enableUserSession && (window === null || window === void 0 ? void 0 : window.sessionStorage)) {
                this._logDebug('Did not detected audiCode or prString in URL, try userSession');
                this._loadUserSession();
            }
        }
    };
    /**
     * Load carId from oneGraph based on AudiCode
     * calls checkCarlineUrl to redirect to the correct carline if the loaded carline
     * is different then current one
     * throws error if the carId could not be loaded
     * @param audiCode
     */
    GlobalStateManager.prototype.loadAudiCode = function (audiCode) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var data, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._oneGraphClient.query({
                                query: gql(Carbycode),
                                variables: { code: audiCode },
                                context: {
                                    consumerId: "STATEMANAGER@1.0.0",
                                },
                            })];
                    case 1:
                        data = (_b.sent()).data;
                        if (isConfiguredCar(data.carByCode) && ((_a = data.carByCode.carline) === null || _a === void 0 ? void 0 : _a.id)) {
                            this.checkCarlineUrl(data.carByCode.carline.id, data.carByCode.id, 'audiCode', audiCode);
                        }
                        else if (isAudiCodeError(data.carByCode)) {
                            throw new Error("Fetching the configured Car from the audicode: ".concat(data.carByCode.code, " failed with error: ").concat(data.carByCode.message, " "));
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _b.sent();
                        console.error('Something went wrong with the fetching of carId from the audicode', e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @description Load carId from oneGraph based on prString
     * calls checkCarlineUrl to redirect to the correct carline if the loaded carline
     * is different then current one
     * throws error if the carId could not be loaded
     * @param prString
     */
    GlobalStateManager.prototype.loadPrString = function (prString) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var prStringParts, modelParts, data, e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        prStringParts = prString.split('|');
                        modelParts = prStringParts[0].split('_');
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._oneGraphClient.query({
                                query: gql(carByPr),
                                variables: {
                                    configuredCarIdentifier: {
                                        brand: 'A',
                                        country: this._carlineInput.country,
                                        equipmentOptions: prStringParts.slice(3),
                                        exteriorColor: prStringParts[1],
                                        interiorColor: prStringParts[2],
                                        language: this._carlineInput.language,
                                        model: {
                                            code: modelParts[0].slice(0, 6),
                                            extensions: [],
                                            version: parseInt(modelParts[0].slice(6), 10),
                                            year: parseInt(modelParts[1], 10),
                                        },
                                    },
                                },
                                context: {
                                    consumerId: "STATEMANAGER@1.0.0",
                                },
                            })];
                    case 2:
                        data = (_b.sent()).data;
                        if (data.configuredCar && ((_a = data.configuredCar.carline) === null || _a === void 0 ? void 0 : _a.id)) {
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            this.checkCarlineUrl(data.configuredCar.carline.id, data.configuredCar.id, 'prString', prString);
                        }
                        else {
                            throw new Error("Fetching the configured Car from the prString: ".concat(prString, " failed since no carline is available "));
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _b.sent();
                        console.error('Something went wrong with the fetching the configuration from PR-String', e_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @description Check if the current url is representing the correct  carline
     * if not redirect to the correct carline
     * @param carline the carline to check
     * @param carId the carId to set
     * @param searchParamsName  the name of the searchParam
     * @param searchParamsValue the value of the searchParam
     */
    GlobalStateManager.prototype.checkCarlineUrl = function (carline, carId, searchParamsName, searchParamsValue) {
        var _a;
        if (carline !== this._carlineInput.carlineId) {
            if (this._carlineID2Urls) {
                var currentUrl = new URL((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href).origin;
                this._setCarId(carId);
                var urlList = this._carlineID2Urls[carline].baseurl;
                var url = new URL(urlList, currentUrl);
                url.searchParams.append(searchParamsName, searchParamsValue);
                /* istanbul ignore next */
                window.location.href = url.href;
            }
            else {
                console.error('Redirect URL not found!');
            }
        }
        else {
            this._setCarId(carId);
            this._removeCarIdTypename();
            // We only need to fetch data is there is actualyl a subscriber
            if (this._subscribers.size > 0) {
                this._fetchData();
            }
            this._logDebug('New carId:', this._carId);
        }
    };
    /**
     * Create the string used as key in the SessionStorage
     *
     * @returns
     */
    GlobalStateManager.prototype.getSessionStorageKey = function () {
        return "__carId_".concat(this._carlineInput.carlineId, "_").concat(this._countryCode.toLowerCase(), "_").concat(this._language.toLowerCase());
    };
    /**
     * Load already configured car from SessionStorage
     */
    GlobalStateManager.prototype._loadUserSession = function () {
        if (this._isSsr) {
            return;
        }
        var savedSessionData = sessionStorage.getItem(this.getSessionStorageKey());
        if (savedSessionData) {
            this._logDebug('Load carId from SessionStorage', this._carId);
            try {
                var parsedSessionStorageData = JSON.parse(savedSessionData);
                var parsedCarId = parsedSessionStorageData.carId;
                var parsedFinancingInput = parsedSessionStorageData.financingInput;
                var isDefaultConfiguration = Boolean(parsedSessionStorageData.isDefaultConfiguration);
                if (isDefaultConfiguration) {
                    this._logDebug('UserSession is a defaultConfiguration so we do nothing', parsedCarId);
                    return;
                }
                if (isCarId(parsedCarId)) {
                    this._loadedFromUserSession = true;
                    this._carId = parsedCarId;
                }
                else {
                    this._log('carId in SessionStorage seems to be have not the correct type', parsedCarId);
                    throw new Error('Invalid carId');
                }
                if (parsedFinancingInput && isfinancingInput(parsedFinancingInput)) {
                    this._financingInput = parsedFinancingInput;
                }
                else {
                    this._log('financingInput in SessionStorage seems to either not exist or have not the correct type', parsedFinancingInput);
                }
            }
            catch (error) {
                this._log('Could not parse the sessionStorage', savedSessionData);
                sessionStorage.removeItem(this.getSessionStorageKey());
            }
        }
        else {
            this._logDebug('No carId in SessionStorage');
        }
    };
    /**
     * Save the current carId in the SessionStorage
     */
    GlobalStateManager.prototype._saveUserSession = function () {
        if (this._isSsr) {
            return;
        }
        if (this._carId && !this._isDefaultConfiguration) {
            this._logDebug('Save carId and financingInput in SessionStorage', this._carId, this._financingInput);
            var sessionData = {
                carId: this._carId,
                financingInput: this._financingInput,
                isDefaultConfiguration: this._isDefaultConfiguration,
            };
            sessionStorage.setItem(this.getSessionStorageKey(), JSON.stringify(sessionData));
        }
        else {
            this._logDebug('No carID or still a DefaultConfiguration to save in SessionStorage');
        }
    };
    /**
     * Remove the __typename as this will break the query if we use it in the input
     */
    GlobalStateManager.prototype._removeCarIdTypename = function () {
        if (this._carId) {
            delete this._carId.__typename;
            delete this._carId.model.__typename;
        }
    };
    /**
     * Set the new carId and fetch the data
     * @param carId the carId to set
     */
    GlobalStateManager.prototype._setConflictSolution = function (carId) {
        if (carId) {
            this._setCarId(carId);
        }
        this._fetchDataSingleSubscribers();
    };
    /**
     * Add or remove a equipment option from the current car.
     *
     * @param equipmentId Either PR3 or PR7
     * @param action
     */
    GlobalStateManager.prototype.changeEquipment = function (equipmentId, action) {
        this._fetchDataSingleSubscribers({ id: equipmentId, action: action });
    };
    /**
     * With that method the current model can be changed.
     * This is usefull fo example if the user wants to change the selected engine
     *
     * @param modelId
     */
    GlobalStateManager.prototype.changeModel = function (modelId) {
        this._fetchDataSingleSubscribers({ id: modelId });
    };
    /**
     * With that method the current trimline can be changed.
     * This is usefull fo example if the user wants to change the selected trimline
     *
     * @param trimline
     */
    GlobalStateManager.prototype.changeTrimline = function (trimline) {
        this._fetchDataSingleSubscribers({ id: trimline });
    };
    /**
     * With that method the current financingInput can be changed.
     * the default financingInput can be set via the StateManagerOptions
     * please use "(financingInput: $financingInput)" in the query to access the
     * financingInput
     * @param financalParameters
     */
    GlobalStateManager.prototype.changeFinancialParameters = function (financalParameters) {
        this._financingInput = financalParameters;
        this._fetchDataSingleSubscribers();
    };
    /**
     * check if the incoming variables are existing or new
     */
    GlobalStateManager.prototype._checkIfVariableUpdated = function (newVar, subscriber) {
        var variableRecord = subscriber && this._lastUsedQueryVariableForSingleQuery.has(subscriber.featureAppId)
            ? this._lastUsedQueryVariableForSingleQuery.get(subscriber.featureAppId)
            : this._lastUsedQueryVariable;
        var lastUsedQueryVariable = (variableRecord !== null && variableRecord !== void 0 ? variableRecord : {});
        for (var _i = 0, newVar_1 = newVar; _i < newVar_1.length; _i++) {
            var varName = newVar_1[_i];
            var name_1 = varName.name.replace('$', '');
            if (!(name_1 in lastUsedQueryVariable))
                return true;
            if (!isEqual(lastUsedQueryVariable[name_1], varName.value))
                return true;
        }
        return false;
    };
    /**
     * With this a app can subscribe to data chanege events and tell the state-manager
     * what ConfiguredCar fields are requested. The FeatureAppId is cleaned up based
     * on the characters allowed in GraphQL aliases.
     *
     * @param featureAppId
     * @param handler
     * @param configuredCarFields
     */
    GlobalStateManager.prototype.subscribe = function (featureAppId, handler, configuredCarFields, variables, configuredCarFieldsForUpdate) {
        var _this = this;
        var cleanFeatureAppId = this.sanitizeFeatureAppId(featureAppId);
        if (this._subscribers.has(cleanFeatureAppId)) {
            throw new Error("A subscriber with the featureAppId '".concat(featureAppId, "' already exists"));
        }
        if (typeof handler !== 'function') {
            throw new Error('It seems like the callback is not a function');
        }
        var newVariables = this._renameVariables(cleanFeatureAppId, variables);
        var newSubscriber = {
            handler: handler,
            configuredCarFields: configuredCarFields,
            configuredCarFieldsForUpdate: configuredCarFieldsForUpdate,
            featureAppId: featureAppId,
            variables: newVariables,
        };
        this._subscribers.set(cleanFeatureAppId, newSubscriber);
        // If used in the client then lets try to recover the state from the server
        if (!this._cachedData && this._serializedStateManager) {
            this._recoverStoredState();
            this._logDebug('Recovered data from server state', this._carId, this._financingInput, this._cachedData);
        }
        var lastUsedVariablesAvailable = this._options.enableSingleQueryMode
            ? this._lastUsedQueryVariableForSingleQuery.size > 0
            : this._lastUsedQueryVariable !== undefined;
        var haveNewUpdated = lastUsedVariablesAvailable && newVariables !== undefined
            ? this._checkIfVariableUpdated(newVariables, this._options.enableSingleQueryMode ? newSubscriber : undefined)
            : false;
        // In single query mode we don't want to the STATEMANAGER required data to every single query
        // So we remove it in the querybuilder if this mode is enabled
        // and add it here as a extra subscriber
        if (this._options.enableSingleQueryMode && !this._subscribers.has('STATEMANAGER')) {
            var stateManagerSubscriber = {
                handler: function () {
                    // do nothing
                },
                configuredCarFields: STATE_MANAGER_QUERY,
                featureAppId: 'STATEMANAGER',
            };
            this._subscribers.set('STATEMANAGER', stateManagerSubscriber);
            var haveNewUpdated_1 = lastUsedVariablesAvailable && newVariables !== undefined
                ? this._checkIfVariableUpdated(newVariables, stateManagerSubscriber)
                : false;
            if (this._cachedData && this._cachedData.STATEMANAGER && !haveNewUpdated_1) {
                this._fetchCachedData(this._options.enableSingleQueryMode
                    ? this._subscribers.get(cleanFeatureAppId)
                    : undefined);
            }
            else {
                this._fetchData(undefined, this._subscribers.get('STATEMANAGER'));
            }
        }
        if (this._cachedData && this._cachedData[cleanFeatureAppId] && !haveNewUpdated) {
            this._logDebug("App with ID ".concat(featureAppId, " has cached data so provide it"));
            this._fetchCachedData(this._options.enableSingleQueryMode ? this._subscribers.get(cleanFeatureAppId) : undefined);
            // If a userSession was loaded, then we return the cachedData from the server for now
            // But will still trigger the fetching of new data
            if (!this._loadedFromUserSession) {
                this._logDebug("App with ID ".concat(featureAppId, " has cached data without a user session"));
                return;
            }
        }
        if (this._options.enableSingleQueryMode) {
            this._fetchData(undefined, newSubscriber);
        }
        else {
            if (this._subscriberDebounceTimer) {
                clearTimeout(this._subscriberDebounceTimer);
            }
            this._subscriberDebounceTimer = setTimeout(function () {
                _this._fetchData();
            }, 100);
        }
    };
    /**
     * Remove subscriber fro mthe subscribers list via featureAppId
     * Will not throw any errors. Will be called automaticly if a App is unmounted.
     *
     * @param featureAppId
     */
    GlobalStateManager.prototype.unsubscribe = function (featureAppId) {
        this._logDebug("App with ID ".concat(featureAppId, " is unsubscribed"));
        this._subscribers.delete(this.sanitizeFeatureAppId(featureAppId));
    };
    /**
     * Return the carIdentifier used for queries. This is only available after
     * the state-manager has done a single query. Or potentialy after a car was loaded
     * via prString or AudiCode
     *
     * @returns
     */
    GlobalStateManager.prototype.getCarId = function () {
        return this._carId;
    };
    /**
     * Function to set the carId and save the new carID in the SessionStorage
     *
     * @param newCarId
     */
    GlobalStateManager.prototype._setCarId = function (newCarId) {
        this._carId = newCarId;
        this._saveUserSession();
    };
    /**
     * Return the carlineInput data used in the query.
     * This depends on the carlineId set during the service setup and is
     * controleld by the integrator.
     * The country and language come from the locale service.
     *
     * @returns
     */
    GlobalStateManager.prototype.getCarlineInput = function () {
        return this._carlineInput;
    };
    /**
     * The fincancingInput data, if available, that will be used in the query
     *
     * @returns
     */
    GlobalStateManager.prototype.getFinancingInput = function () {
        return this._financingInput;
    };
    /**
     * The WebCalcDomain, if available
     *
     * @returns
     */
    GlobalStateManager.prototype.getWebCalcDomain = function () {
        return this._webCalcDomain;
    };
    /**
     * Show if currently the debug mode is activated. Apps can use this to display extra data etc.
     * This is set during the definition of the service in the inegrator
     *
     * @returns
     */
    GlobalStateManager.prototype.isDebug = function () {
        return Boolean(this._options.debug);
    };
    /**
     * Function to notify the subscriber about the events and available data
     *
     * @param event The specific event to notify about
     * @param variables The oneGraph variables used
     * @param data If available the ocnfiguredCar data
     */
    GlobalStateManager.prototype._notifySubscribers = function (event, variables, data) {
        var _this = this;
        this._logDebug('Notifing subscribers', event, variables, data, this._subscribers.keys);
        if (this._subscribers.size === 0) {
            this._logDebug('No subscribers available to notify');
            return;
        }
        this._subscribers.forEach(function (singleSubscriber, featureAppId) {
            // eslint-disable-next-line no-undef-init
            var carData = undefined;
            if (event === StateEvents.NEW_DATA && data) {
                var carDataToClone = isSpecificCarData(data[featureAppId])
                    ? data[featureAppId].configuredCar
                    : data[featureAppId];
                if (carDataToClone)
                    carData = JSON.parse(JSON.stringify(carDataToClone));
                if (!carData) {
                    _this._log("The subscriber '".concat(featureAppId, "' has no data, that seems wrong"));
                }
            }
            singleSubscriber.handler(event, variables, carData);
        });
    };
    GlobalStateManager.prototype._notifySingleSubscriber = function (subscriber, event, variables, data) {
        this._logDebug('Notifing subscriber', event, variables, data, subscriber);
        // eslint-disable-next-line no-undef-init
        var carData = undefined;
        var cleanFeatureAppId = this.sanitizeFeatureAppId(subscriber.featureAppId);
        if (event === StateEvents.NEW_DATA && data) {
            var carDataToClone = isSpecificCarData(data[cleanFeatureAppId])
                ? data[cleanFeatureAppId].configuredCar
                : data[cleanFeatureAppId];
            if (carDataToClone)
                carData = JSON.parse(JSON.stringify(carDataToClone));
            if (!carData) {
                this._log("The subscriber '".concat(cleanFeatureAppId, "' has no data, that seems wrong"));
            }
        }
        subscriber.handler(event, variables, carData);
    };
    /**
     * Actually fetching the data and notifying the subscribers.
     * Would also trigger the conflict handling if needed. After a request
     * the carId will be updated.
     *
     * @param changeRequest Can be a EquipmentChange or ModelChange or nothing.
     * Based on that the query variables will be adjusted
     */
    GlobalStateManager.prototype._fetchData = function (changeRequest, singleSubscriber) {
        return __awaiter(this, void 0, void 0, function () {
            var queryBuilder, queryVariables, query, queryPromise;
            var _this = this;
            return __generator(this, function (_a) {
                queryBuilder = new QueryBuilder(this._carId || this._carlineInput, this._options.enableSingleQueryMode).setQueryType(QueryType.DefaultConfig);
                if (singleSubscriber) {
                    this._logDebug('Single subscriber fetch', singleSubscriber);
                    queryBuilder.addQuery(this.sanitizeFeatureAppId(singleSubscriber.featureAppId), singleSubscriber.configuredCarFields, singleSubscriber.configuredCarFieldsForUpdate, singleSubscriber.variables);
                }
                else {
                    this._subscribers.forEach(function (subscriber, cleanFeatureAppId) {
                        queryBuilder.addQuery(cleanFeatureAppId, subscriber.configuredCarFields, subscriber.configuredCarFieldsForUpdate, subscriber.variables);
                    });
                }
                queryVariables = {
                    configuredCar: this._carlineInput,
                    financingInput: this._financingInput,
                };
                if (this._carId && !changeRequest) {
                    this._logDebug('Build request with carId', this._carId);
                    queryVariables = {
                        configuredCar: this._carId,
                        financingInput: this._financingInput,
                    };
                    queryBuilder.setQueryType(QueryType.SpecificConfig);
                }
                else if (this._carId && isEquipmentChange(changeRequest)) {
                    this._logDebug('Build request with carId and feature change', this._carId, changeRequest);
                    queryVariables = {
                        configuredCar: {
                            action: changeRequest.action,
                            autoResolveConflicts: this._options.enableSimpleConflictResolution,
                            feature: changeRequest.id,
                            id: this._carId,
                        },
                        financingInput: this._financingInput,
                    };
                    queryBuilder.setQueryType(QueryType.ChangeEquipment);
                }
                else if (this._carId && isModelChange(changeRequest)) {
                    this._logDebug('Build request with carId and model change', this._carId, changeRequest);
                    queryVariables = {
                        configuredCar: {
                            autoResolveConflicts: this._options.enableSimpleConflictResolution,
                            model: changeRequest.id,
                            id: this._carId,
                        },
                        financingInput: this._financingInput,
                    };
                    queryBuilder.setQueryType(QueryType.ChangeModel);
                }
                else if (this._carId && isTrimlineChange(changeRequest)) {
                    this._logDebug('Build request with carId and trimline change', this._carId, changeRequest);
                    queryVariables = {
                        configuredCar: {
                            autoResolveConflicts: this._options.enableSimpleConflictResolution,
                            trimline: changeRequest.id,
                            id: this._carId,
                        },
                        financingInput: this._financingInput,
                    };
                    queryBuilder.setQueryType(QueryType.ChangeTrimline);
                }
                query = queryBuilder.buildQuery();
                if (singleSubscriber === null || singleSubscriber === void 0 ? void 0 : singleSubscriber.variables) {
                    if (singleSubscriber.variables && singleSubscriber.variables.length > 0) {
                        singleSubscriber.variables
                            .sort(function (_a, _b) {
                            var a = _a.rawName;
                            var b = _b.rawName;
                            return a.localeCompare(b);
                        })
                            .forEach(function (singleVariable) {
                            var key = singleVariable.name.replace('$', '');
                            queryVariables[key] = singleVariable.value;
                        });
                    }
                }
                else if (this._subscribers.size > 0) {
                    Array.from(this._subscribers.values())
                        .sort(function (_a, _b) {
                        var a = _a.featureAppId;
                        var b = _b.featureAppId;
                        return a.localeCompare(b);
                    })
                        .forEach(function (subscriber) {
                        if (subscriber.variables && subscriber.variables.length > 0) {
                            subscriber.variables
                                .sort(function (_a, _b) {
                                var a = _a.rawName;
                                var b = _b.rawName;
                                return a.localeCompare(b);
                            })
                                .forEach(function (singleVariable) {
                                var key = singleVariable.name.replace('$', '');
                                queryVariables[key] = singleVariable.value;
                            });
                        }
                    });
                }
                this._logDebug('Query will runn the following query', query, queryBuilder, queryVariables);
                try {
                    if (singleSubscriber) {
                        this._notifySingleSubscriber(singleSubscriber, StateEvents.FETCHING_DATA, queryVariables);
                    }
                    else {
                        this._notifySubscribers(StateEvents.FETCHING_DATA, queryVariables);
                    }
                    // Remove the __typename as this will break the query if we use it in the input
                    this._removeCarIdTypename();
                    queryPromise = (function () { return __awaiter(_this, void 0, void 0, function () {
                        var data, acceptConflictSolutions, clonedData_1, cleanedData_1;
                        var _this = this;
                        var _a, _b, _c, _d, _e;
                        return __generator(this, function (_f) {
                            switch (_f.label) {
                                case 0: return [4 /*yield*/, this._oneGraphClient.query({
                                        query: gql(query),
                                        variables: queryVariables,
                                        context: {
                                            consumerId: "STATEMANAGER@1.1.0",
                                        },
                                        errorPolicy: 'ignore',
                                    })];
                                case 1:
                                    data = (_f.sent()).data;
                                    // check if the query result has a conflict
                                    if (!this._options.enableSimpleConflictResolution &&
                                        (((_a = data.STATEMANAGER) === null || _a === void 0 ? void 0 : _a.conflict) ||
                                            (Array.isArray((_b = data.STATEMANAGER) === null || _b === void 0 ? void 0 : _b.sideEffects) &&
                                                ((_c = data.STATEMANAGER) === null || _c === void 0 ? void 0 : _c.sideEffects.length) > 0))) {
                                        acceptConflictSolutions = function (carId) {
                                            _this._setConflictSolution(carId);
                                        };
                                        if (this._carId) {
                                            openConfigAssistant(this._layerManager, data.STATEMANAGER, FeatureChangeAction.Add, this._carId, this._options.configAssistantVersion, this._financingInput, acceptConflictSolutions);
                                        }
                                    }
                                    else {
                                        if (queryBuilder.getQueryType() !== QueryType.DefaultConfig) {
                                            this._logDebug('Config is no longer a default config');
                                            this._isDefaultConfiguration = false;
                                        }
                                        // if no conflict, just update the carId and notify the subscribers
                                        this._logDebug('Got data from oneGraph', data, query, queryVariables);
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        if (data.STATEMANAGER) {
                                            this._setCarId(
                                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                            ((_d = data.STATEMANAGER) === null || _d === void 0 ? void 0 : _d.id) || ((_e = data.STATEMANAGER) === null || _e === void 0 ? void 0 : _e.configuredCar.id));
                                            this._logDebug('New carId:', this._carId);
                                        }
                                        clonedData_1 = JSON.parse(JSON.stringify(data));
                                        cleanedData_1 = {};
                                        this._subscribers.forEach(function (_, cleanFeatureAppId) {
                                            if (clonedData_1[cleanFeatureAppId]) {
                                                var dataForSubscriber = clonedData_1[cleanFeatureAppId].configuredCar
                                                    ? clonedData_1[cleanFeatureAppId].configuredCar
                                                    : clonedData_1[cleanFeatureAppId];
                                                cleanedData_1[cleanFeatureAppId] = dataForSubscriber;
                                            }
                                        });
                                        // We are merging the last cached (complete) data with the current data with may contain
                                        // less data as a update request was used
                                        if (this._cachedData &&
                                            ((this._carId && isEquipmentChange(changeRequest)) ||
                                                (this._isSsr && this._options.enableSingleQueryMode))) {
                                            merge(this._cachedData, this._cachedData, cleanedData_1);
                                            cleanedData_1 = this._cachedData;
                                        }
                                        // This cache is used for update requests and SSR
                                        this._cachedData = cleanedData_1;
                                        if (this._options.enableSingleQueryMode && singleSubscriber) {
                                            this._lastUsedQueryVariableForSingleQuery.set(singleSubscriber === null || singleSubscriber === void 0 ? void 0 : singleSubscriber.featureAppId, queryVariables);
                                        }
                                        else {
                                            this._lastUsedQueryVariable = queryVariables;
                                        }
                                        if (singleSubscriber) {
                                            this._notifySingleSubscriber(singleSubscriber, StateEvents.NEW_DATA, queryVariables, cleanedData_1);
                                        }
                                        else {
                                            this._notifySubscribers(StateEvents.NEW_DATA, queryVariables, cleanedData_1);
                                        }
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); })();
                    if (this._asyncSsrManager) {
                        this._asyncSsrManager.scheduleRerender(queryPromise);
                    }
                }
                catch (e) {
                    if (singleSubscriber) {
                        this._notifySingleSubscriber(singleSubscriber, StateEvents.ERROR, queryVariables, undefined);
                    }
                    else {
                        this._notifySubscribers(StateEvents.ERROR, queryVariables, undefined);
                    }
                    console.error('Something went wrong with the fetching of oneGraph data', e);
                }
                return [2 /*return*/];
            });
        });
    };
    GlobalStateManager.prototype._fetchDataSingleSubscribers = function (changeRequest) {
        var _this = this;
        var _a;
        if (this._options.enableSingleQueryMode) {
            (_a = this._subscribers) === null || _a === void 0 ? void 0 : _a.forEach(function (singleSubscriber) {
                _this._fetchData(changeRequest, singleSubscriber);
            });
        }
        else {
            this._fetchData(changeRequest);
        }
    };
    /**
     * uses the cached data to notify all subscribers
     * This is used after SSR to provider the SSR state
     */
    GlobalStateManager.prototype._fetchCachedData = function (subscriber) {
        var _a, _b;
        if (subscriber) {
            this._notifySingleSubscriber(subscriber, StateEvents.NEW_DATA, (_a = this._lastUsedQueryVariableForSingleQuery.get(subscriber.featureAppId)) !== null && _a !== void 0 ? _a : {}, this._cachedData);
        }
        else {
            this._notifySubscribers(StateEvents.NEW_DATA, (_b = this._lastUsedQueryVariable) !== null && _b !== void 0 ? _b : {}, this._cachedData);
        }
    };
    /**
     * Log info message, if logger service is available
     *
     * @param message
     * @param data
     */
    GlobalStateManager.prototype._log = function (message) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        if (this._logger) {
            this._logger.info(message, data);
        }
    };
    /**
     * Log debug message, if debug mode is enabled and logger service is available
     *
     * @param message
     * @param data
     */
    GlobalStateManager.prototype._logDebug = function (message) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        if (this._logger && this.isDebug()) {
            this._logger.debug("GlobalStateManager: ".concat(message), data);
        }
    };
    GlobalStateManager.prototype.isSubscribed = function (featureAppId) {
        return this._subscribers.has(this.sanitizeFeatureAppId(featureAppId));
    };
    // eslint-disable-next-line class-methods-use-this
    GlobalStateManager.prototype.sanitizeFeatureAppId = function (id) {
        return id.replace(/[^a-zA-Z0-9]/g, '_');
    };
    /**
     *  With this the Integrator can get the state of the oneGraph client after rendering everythings
     *
     * @returns
     */
    GlobalStateManager.prototype._getStateToSave = function () {
        var stateToSave = {
            carId: this._carId,
            financingInput: this._financingInput,
            cachedData: this._cachedData,
            lastUsedQueryVariable: this._lastUsedQueryVariable,
            lastUsedQueryVariableForSingleQuery: Array.from(this._lastUsedQueryVariableForSingleQuery),
        };
        return JSON.stringify(stateToSave);
    };
    GlobalStateManager.prototype._recoverStoredState = function () {
        if (this._serializedStateManager && !this._isSsr) {
            var rawStoredData = this._serializedStateManager.getSerializedState();
            if (rawStoredData) {
                var storedData = JSON.parse(rawStoredData);
                this._cachedData = storedData.cachedData;
                // We don't override the carId etc if a session was loaded
                // But we will take the cachedData
                if (!this._loadedFromUserSession) {
                    this._carId = storedData.carId;
                    this._financingInput = storedData.financingInput;
                    this._lastUsedQueryVariable = storedData.lastUsedQueryVariable;
                    this._lastUsedQueryVariableForSingleQuery =
                        storedData._lastUsedQueryVariableForSingleQuery
                            ? new Map(storedData._lastUsedQueryVariableForSingleQuery)
                            : new Map();
                }
            }
            else {
                this._logDebug('No stored state found');
            }
        }
    };
    /**
     * Takes varibales and makes sure that hthe name fits to the using FeatureApp
     *
     * @param cleanFeatureAppId
     * @param variables
     * @returns
     */
    // eslint-disable-next-line class-methods-use-this
    GlobalStateManager.prototype._renameVariables = function (cleanFeatureAppId, variables) {
        var _this = this;
        if (!variables) {
            return variables;
        }
        var newVariables = [];
        Object.keys(variables).forEach(function (varName) {
            var newVariable = {
                rawName: varName,
                name: "$".concat(cleanFeatureAppId).concat(_this.sanitizeFeatureAppId(varName)),
                value: variables[varName].value,
                type: variables[varName].type,
            };
            newVariables.push(newVariable);
        });
        return newVariables;
    };
    return GlobalStateManager;
}());
export { GlobalStateManager };
//# sourceMappingURL=global-state-manager.js.map